module.exports = __webpack_public_path__ + "img/checklist.87276733.svg";